module.exports = __webpack_public_path__ + "img/icon_anthropometry.30667717.svg";